// filepath: admin-dashboard/src/components/layout/Sidebar.tsx
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useProject, ProjectId } from '../../context/ProjectContext';
import { getCollectionsForProject, PROJECT_LABELS } from '../../config/collectionRegistry';

const PROJECT_OPTIONS: ProjectId[] = ['admiral', 'bolt-jr'];

export const Sidebar: React.FC = () => {
  const { isAdmin } = useAuth();
  const { project, setProject } = useProject();
  const navigate = useNavigate();

  const collections = getCollectionsForProject(project);

  const handleProjectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setProject(e.target.value as ProjectId);
    navigate('/');
  };

  return (
    <aside className="bg-gray-800 text-white w-64 min-h-screen p-4">
      <h1 className="text-2xl font-bold mb-4">
        <NavLink to="/" className="hover:text-gray-300">
          Admin Dashboard
        </NavLink>
      </h1>

      {/* Project selector */}
      <div className="mb-6">
        <label htmlFor="project-select" className="block text-xs uppercase tracking-wider text-gray-400 mb-1">
          Project
        </label>
        <select
          id="project-select"
          value={project}
          onChange={handleProjectChange}
          className="w-full bg-gray-700 text-white border border-gray-600 rounded px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          {PROJECT_OPTIONS.map((p) => (
            <option key={p} value={p}>
              {PROJECT_LABELS[p]}
            </option>
          ))}
        </select>
      </div>

      <nav>
        <ul>
          {/* Content section label */}
          <li className="mb-2 px-2 text-xs uppercase tracking-wider text-gray-400">
            Content
          </li>

          {collections.map(({ name, path }) => (
            <li key={path} className="mb-4">
              <NavLink
                to={path}
                className={({ isActive }) =>
                  `block px-2 py-1 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
                }
              >
                {name}
              </NavLink>
            </li>
          ))}

          {/* Admin-only section */}
          {isAdmin && (
            <>
              <li className="mt-6 mb-2 px-2 text-xs uppercase tracking-wider text-gray-400">
                Admin
              </li>
              <li className="mb-4">
                <NavLink
                  to="/users"
                  className={({ isActive }) =>
                    `block px-2 py-1 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
                  }
                >
                  Users
                </NavLink>
              </li>
            </>
          )}
        </ul>
      </nav>
    </aside>
  );
};
